export default "__VITE_ASSET__DjwA1Qup__"